// form
import { FormProvider as Form } from 'react-hook-form';


export default function FormProvider({ children, onSubmit, methods }) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit} noValidate autoComplete="off">
        {children}
      </form>
    </Form>
  );
}
